<template>
  <div>
    <el-dialog
      v-for="(data, index) in bankWithdrawSocketDataList"   
      :key="index"
      custom-class="c2cPopup-container"
      :visible="data.showDialog"
      :close-on-click-overlay="false"
      @close="closePopup(data)"
      :style="{ background: 'rgba(0, 0, 0, .5) !important' }"
      width="452px"
    >
      <template slot="default">
        <div v-if="nonReceive" class="c2cPopup">
          <div class="titleCtx">
            <p>
              <span style="flex: 1"></span>
              <span style="flex: 1">凭证填写</span>
              <span style="flex: 1; display: flex"></span>
            </p>
          </div>
          <div
            style="margin-top: 1.5vh; display: flex; flex-direction: column"
          >
            <!-- <el-upload  :on-change="(file) => afterRead(data, file)" @on-remove="data.uploadImg = null" accept="image/*" :limit="1" list-type="picture-card" :auto-upload="false" action="#"> -->
            <img
              v-if="data.localImgUrl"
              :src="data.localImgUrl"
              fit="contain"
              style="width: 100px;"
            />
            <el-upload v-else :on-change="(file) => afterRead(data, file)" accept="image/*" :auto-upload="false" action="#">
              <div class="upload-wrapper"  >
                <img src="./img/upload.png"/>
              </div>
            </el-upload>
            <p class="upload-text"> 上传凭证 </p>
            <p class="tips">图片小于等于10M</p>
          </div>

          <div class="input-wrapper">
            <el-input
              class="textarea-box"
              v-model="data.userContent"
              clearable=""
              placeholder="请输入您的描述信息"
              type="textarea"
              maxlength="300"
              show-word-limit
              :rows="5"
            ></el-input>
          </div>

          <div class="btnArea">
            <div
                class="btn"
                style="background: #b56d6c"
                @click="nonReceive=false"
              >
              返回上一步
            </div>
            <button
              class="btn"
              :class="{'is-disabled':!data.userContent || !data.localImgUrl}"
              :disabled="!data.userContent || !data.localImgUrl"
              style="margin-bottom: 1.5vh"
              @click="withdrawConfirm(data, 1)"
            >
              已完成填写
            </button>
          </div>
        </div>
        <div v-else class="c2cPopup">
          <div class="titleCtx">
            <p>
              <span style="flex: 1"></span>
              <span style="flex: 1">待确认收款</span>
              <span style="flex: 1; display: flex">
                <span style="flex: 1"></span>
              </span>
            </p>
          </div>
          <div style="margin-top: 1.5vh">
            <img src="./img/img.png" width="34"/>
          </div>
          
          <span class="amount">
            ¥ {{ data.amount }}
          </span>
          <div class="content" :class="{nodata: !data.content }">
            {{ data.content }}
          </div>
          <div class="detail">
            <div>时间: {{ data.transTime }}</div>
            <div>订单号: {{ data.transNo }} <span class="copy-btn" v-clipboard:copy="data.transNo" v-clipboard:success="onCopy">复制</span></div>
          </div>
          <div class="btnArea">
            <div
              class="btn"
              style="background: #b56d6c"
              @click="nonReceiveAction(data,1)"
            >
              未到账
            </div>
            <div
              class="btn"
              style="background: #54a641"
              @click="openWithdrawConfirm(data, 0)"
            >
              已到账
            </div>
          </div>
          <div class="footerArea">
            <el-checkbox v-model="data.hidePopupOptions.hide">{{ data.popupTime }}分钟不再弹框</el-checkbox>
          </div>
        </div>
        <div v-if="doneAlert" class="doneAlert">
          <div class="c2cPopup">
            <div class="titleCtx">
              <p>
                <span style="flex: 1"></span>
                <span style="flex: 1">确认提示</span>
                <span style="flex: 1; display: flex">
                  <span style="flex: 1"></span>
                </span>
              </p>
            </div>  
            <div class="detail">
              <div>请确认是否<span style="color: red">已到账？</span></div>
            </div>
            <div class="btnArea">
              <div
                class="btn"
                style="background: #f4f4f4;color: #000000;"
                @click="doneAlert=false"
              >
                关闭
              </div>
              <div
                class="btn"
                style="background: #54a641"
                @click="withdrawConfirm(data, 0)"
              >
                确定
              </div>
            </div>
          </div>
        </div>
        <div v-if="unDoneAlert" class="doneAlert">
          <div class="c2cPopup">
            <div class="titleCtx">
              <p>
                <span style="flex: 1"></span>
                <span style="flex: 1">确认提示</span>
                <span style="flex: 1; display: flex">
                  <span style="flex: 1"></span>
                </span>
              </p>
            </div>  
            <div class="detail">
              <div>请确认是否<span style="color: red">未到账？</span></div>
            </div>
            <div class="btnArea">
              <div
                class="btn"
                style="background: #f4f4f4;color: #000000;"
                @click="unDoneAlert=false"
              >
                关闭
              </div>
              <div
                class="btn"
                style="background: #54a641"
                @click="withdrawConfirm(data, 1)"
              >
                确定
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { commonApi } from "@/common/index";
import dayjs from "dayjs";

class C2cData {
  constructor(resp) {
    this.amount = resp.amount;
    this.content = resp.content;
    this.needUpload = resp.needUpload; //<'0'|'1'>needUpload 未到账是否需要上传图片凭证，'this.0'=需要 '1'不需要
    this.transId = resp.transId;
    this.transNo = resp.transNo;
    this.transTime = resp.transTime;
    this.popupTime = resp.popupTime;
    this.type = resp.type;
    this.userAccount = resp.userAccount;
    this.userContent = resp.userContent;
    this.localImgUrl = resp.localImgUrl;
    this.showDialog = true;
    this.uploadImg = null;
    this.hidePopupOptions = {
      hide: false,
      hideStartTime: resp.transTime,
      hidePeriod: resp.popupTime, //分鐘
      hideEndTime: dayjs(resp.transTime)
        .add(resp.popupTime, "m")
        .format("YYYY-MM-DD HH:mm"),
    };
  }
}

export default {
  name: "c2cPopup",
  data() {
    return {
      showDialog: false,
      bankWithdrawSocketDataList: {},
      nonReceive: false,
      doneAlert: false,
      unDoneAlert: false,
      name:'',
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.isLogin,
      userInfo: (state) => state.userInfo.userInfo,
    }),
  },
  watch: {
    isLogin: {
      handler(val) {
        if (!val) {
          this.bankWithdrawSocketDataList = {};
          //this.$globalSocket.unsubscribeAll();
        }
      },
    },
    userInfo: {
      immediate: true,
      deep:true,
      handler(val) {
        if(val.userAccount){
          if (Object.keys(val).length) {
            this.initSocket()
          };
        }else{
          try {
            //this.$globalSocket.subscribeList = [];
            this.$globalSocket.unsubscribe(this.name);
          } catch (error) {
            console.log('未订阅')
          }
        }
      },
    },

    // $route() {
    //     const dataList = Object.values(this.bankWithdrawSocketDataList);
    //     if (dataList.length > 0) {
    //       Object.values(this.bankWithdrawSocketDataList).forEach((item) => {
    //         item.showDialog = !item.hidePopupOptions.hide;
    //       });
    //     }
    //   }
    // },
  },
  async mounted() {
    await this.$globalSocket.connect();
    //this.getLocalData();
    this.initSocket();
  },

  methods: {
    onCopy() {
      this.$message.success('复制成功');
    },

    nonReceiveAction(data,val) {
      if(data.needUpload == 0){
        this.$nextTick(() => {
          this.nonReceive = true;
        });
      }else{
        this.$nextTick(() => {
          this.unDoneAlert = true;
        });
        // this.$confirm('请确认是否未到账？', '提示', {
        //   confirmButtonText: '是',
        //   cancelButtonText: '否',
        //   type: 'warning'
        // }).then(() => {
        //   this.withdrawConfirm(data,0)
        // }).catch(() => { 
        //   this.withdrawConfirm(data,1)       
        // });
      }
    },
    closePopup(data) {
      this.$set(data, 'showDialog', false);
      this.nonReceive = false;
      this.saveDataToLocal();
    },

    restBankWithdrawSocketData() {
      this.nonReceive = false;
    },

    afterRead(data, file) {
        const vm = this;
        console.log(file)
        const maxSize = 10 * 1024 * 1024;
        const reader = new FileReader();
        if(file.raw.size > maxSize) {
          return this.$message.error('图片需要小于等于10M')
        }
        data.uploadImg = file.raw
        reader.readAsDataURL(file.raw);
        reader.onload = (e) => {
          vm.$nextTick(() => {
            vm.$set(data, 'localImgUrl', e.target.result)
            // data.localImgUrl = e.target.result;
            // data.uploadImg =  e.target.result;
            console.log(e.target)
          });
        };
        // reader.readAsDataURL(file.raw); // 以DataURL形式读取文件
    },
    openWithdrawConfirm(data,val) {
      this.$nextTick(() => {
        this.doneAlert = true;
      });
      // this.$confirm('请确认是否已到账？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.withdrawConfirm(data,val)
      // }).catch(() => {        
      // });
    },
    withdrawConfirm(data, transStatus) {
      const params = {
        transId: data.transId,
        transStatus, //到账状态确定,0:已到账 1:未到账
        content: data.userContent || "",
        uploadImg: null,
      };
      if (data.needUpload == 0 && transStatus === 1) {
        params.uploadImg = data.uploadImg;
      }
      console.log(params, data)
      commonApi.PAY.withdrawConfirm(params)
        .then(() => {
          data.showDialog = false;
          if (transStatus === 0) {
            this.$nextTick(() => {
              delete this.bankWithdrawSocketDataList[data.transId];
            });
          }
          this.$message.success(transStatus === 1 ? "已通知后台" : "已到账");
        })
        .catch((err) => {
          data.showDialog = false;
          console.warn("err", err);
        })
        .finally(() => {
          data.uploadImg = null;
          data.localImgUrl = null;
          data.userContent = null;
          this.nonReceive = false;
          this.saveDataToLocal();
          this.unDoneAlert = false;
          this.doneAlert = false;
        });
    },

    async initSocket() {
      if (!this.userInfo.userAccount) {
        return false
      };

      this.name = `/userMsg/${this.userInfo.userAccount}/guest/getMsg`
      this.$globalSocket.subscribe(this.name, async (resp) => {
          console.log(`${dayjs().format("YYYY-MM-DD HH:mm:ss")} resp`, resp);
          await this.$nextTick();
          
          if (resp && resp.type == 303) {
            const optionsData = new C2cData(resp);
            // 假如第一次对象存在，并且有数据，更改第二层数据
            if (this.bankWithdrawSocketDataList[resp.transId]) {
              Object.keys(this.bankWithdrawSocketDataList[resp.transId]).forEach(elem => {
                this.$set(this.bankWithdrawSocketDataList[resp.transId], elem, optionsData[elem]);
              });
            } else {
              this.$set(this.bankWithdrawSocketDataList, resp.transId, optionsData);
            }

            this.saveDataToLocal();
          }
        }
      );
    },

    saveDataToLocal() {
      localStorage.setItem(
        "bankWithdrawSocketDataList",
        JSON.stringify(this.bankWithdrawSocketDataList)
      );
    },

    getLocalData() {
      const bankWithdrawSocketDataList = localStorage.getItem(
        "bankWithdrawSocketDataList"
      );
      console.log("bankWithdrawSocketDataList", !!bankWithdrawSocketDataList);

      if (bankWithdrawSocketDataList) {
        const localData = JSON.parse(bankWithdrawSocketDataList);
        Object.values(localData).forEach((item) => {
          item.showDialog = !item.hidePopupOptions.hide;
        });

        this.bankWithdrawSocketDataList = localData;
      }
    },
  },
};
</script>


<style lang="scss" scoped>
  
/deep/ .c2cPopup-container {
  border-radius: 10px;
  position: relative;
  .textarea-box{
    position: relative;
  }
  .el-input__count{
    position: absolute;
    right: 9px;
    top: 98px;
  }
  .el-checkbox__inner{
    border: 1px solid #F9BE1A !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #7C6118 !important;
  }
  .el-dialog__header {
    position: absolute;
    height: 50px;
    top: 0;
    left: 0;
    z-index: 20;
    width: 100%;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.c2cPopup {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-bottom: 20px;
  border: 6px solid #F9BE1A;
  border-radius: 10px;
  .titleCtx {
    background: #ffffff;
    height: 50px;
    line-height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    color: #3A4452;
    border-radius: 10px 10px 0 0;
    p{
      height: 36px;
      width: 180px;
      align-items: center;
      background: #F9BE1A;
      color: #2D1916;
      line-height: 36px;
      border-radius: 4px;
      position: absolute;
      left: 50%;
      margin-left: -90px;
      top: -17px;
      z-index: 9999;
    }
  }

  .content {
    color: #A3A3A3;
    padding: 10px;
    border-top: 1px dashed #F0F0F0;
    border-bottom: 1px dashed #F0F0F0;
    width: 84%;
    min-height: 80px;
    margin-top: 20px;
    line-height: 1.6;
    &.nodata {
      min-height: 0;
      border-bottom: none;
      padding: 0;
    }
  }

  .detail {
    margin-top: 19px;
    margin-bottom: 15px;
    div {
      font-size: 16px;
      color: #3A4452;
      text-align: center;
      margin-bottom: 10px;
      font-weight: 550;
    }
  }

  .btnArea {
    display: flex;
    width: 80%;
    justify-content: space-around;

    .btn {
      color: white;
      border-radius: 4px;
      width: 158px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      border: 0;
      background: #54a641;
    }
    .is-disabled{
      opacity: 0.5;
      cursor: no-drop;
    }
  }

  .footerArea {
    display: flex;
    align-items: center;
    color: #A3A3A3;
    padding-top: 33px;
    font-size: 16px;
    /deep/ .el-checkbox__label {
      color: #A3A3A3;
    }
  }
}
.doneAlert{
  position: fixed;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, .5);
  .c2cPopup {
    width: 310px;
    background: #fff;
    padding-bottom: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: absolute;
    left: 50%;
    margin-left: -155px;
    top: 50%;
    margin-top: -90px;

    .titleCtx {
      border-radius: 10px 10px 0 0;
      background: #ffffff;
      height: 50px;
      line-height: 50px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 20px;
      font-weight: bold;
      color: #3A4452;
      p{
        height: 36px;
        width: 180px;
        align-items: center;
        background: #F9BE1A;
        color: #2D1916;
        line-height: 36px;
        border-radius: 4px;
        position: absolute;
        left: 50%;
        margin-left: -90px;
        top: -22px;
        z-index: 9999;
      }
    }

    .content {
      color: #A3A3A3;
      padding: 10px;
      border-top: 1px dashed #F0F0F0;
      border-bottom: 1px dashed #F0F0F0;
      width: 84%;
      min-height: 80px;
      margin-top: 20px;
      line-height: 1.6;
      &.nodata {
        min-height: 0;
        border-bottom: none;
        padding: 0;
      }
    }

    .detail {
      margin-top: 19px;
      margin-bottom: 15px;
      div {
        font-size: 16px;
        color: #3A4452;
        text-align: center;
        margin-bottom: 10px;
        font-weight: 550;
      }
    }

    .btnArea {
      display: flex;
      width: 80%;
      justify-content: space-around;

      .btn {
        color: white;
        border-radius: 4px;
        width: 158px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        margin: 0 10px;
        cursor: pointer;
      }
    }
  }
}
.amount {
  margin-top: 10px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #3A4452;
}

.copy-btn {
  color: #A3A3A3;
  border-bottom: 1px solid #A3A3A3;
  padding-bottom: 1px;
  font-weight: normal;
  cursor: pointer;
}

.upload-wrapper {
  width: 110px;
  height: 110px;
  background-color: #F8F8F8;
  border: 1px dashed #C9C9C9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;

  img {
    width: 64px;
  }
}

.upload-text {
  color:#000000;
  padding-top: 10px;
  padding-bottom: 10px;
}

.tips {
  color: #D12C2C;
}

.input-wrapper {
  width: 360px;
  margin: 30px 0;
}

</style>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/build08/components/c2cPopup/c2cPopup.vue